"use client";

import { useRouter } from "next/navigation";
import { useEffect, useTransition } from "react";

import AuthPaywall from "@/components/shared/auth-paywall/auth-paywall";
import { useAuth } from "@/stores/use-auth";

export default function RefreshingAuthPaywall({ testId }: { testId?: string }) {
  const router = useRouter();
  const { isLoading, user } = useAuth();
  const [isRefreshing, startRefresh] = useTransition();

  useEffect(() => {
    if (user) {
      startRefresh(() => router.refresh());
    }
  }, [user, router]);

  return <AuthPaywall isLoading={isLoading || isRefreshing} testId={testId} />;
}
